import styled from "styled-components";

const primaryColor = "#15b5b0";

export const Container = styled.div`
  margin: 0 auto;
  padding: 0px 20px 0px 20px;
`;

export const Title = styled.h1`
  font-family: "Baloo", cursive;
  color: ${primaryColor};
  text-align: center;
  font-size: 3rem;
  margin-bottom: 40px;
`;

export const Iframe = styled.iframe`
  display: block;
  width: 100%;
  height: 50vh;
  border: 0;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    height: 65vh;
  }
`;
